module.exports = __webpack_public_path__ + "img/1-01.6c409e23.svg";